import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { DatePipe } from '@angular/common';
import constant from '../app.constant';

@Pipe({ name: 'dateFormat' })
@Injectable()
export class Mypipe extends DatePipe implements PipeTransform {
    transform(date: any, format: string): any {
        if (date) {
            return moment(date).format(format);
        }
    }
}



